/**
 * Step 1 — Normalisation (internal).
 * Trim, remove invisible chars, collapse repeated characters.
 * Spec "Lowercase" is applied only where needed for comparison (e.g. reserved terms);
 * normalised output may keep original case for display/storage.
 * Used before validation and before submit (backend will re-apply).
 */

const INVISIBLE_AND_CONTROL = /[\u200B-\u200D\u2060\uFEFF\u0000-\u001F\u007F-\u009F]/g;
const MULTIPLE_SPACES = /\s+/g;
const REPEATED_CHAR = /(.)\1{2,}/g; // 3+ same char -> collapse to 2

/**
 * @param {string} text
 * @returns {string}
 */
export function normalizeText(text) {
  if (text == null || typeof text !== 'string') return '';
  let t = text
    .replace(INVISIBLE_AND_CONTROL, '')
    .replace(MULTIPLE_SPACES, ' ')
    .trim();
  // Collapse repeated chars (fuuuuck -> fuuck; we keep 2 for valid words like "letter")
  t = t.replace(REPEATED_CHAR, '$1$1');
  return t;
}

/**
 * Normalise and optionally lowercase (for comparison only; stored value can keep case).
 * @param {string} text
 * @param {{ lowercase?: boolean }} [opts]
 * @returns {string}
 */
export function normalizeForValidation(text, opts = {}) {
  let t = normalizeText(text);
  if (opts.lowercase) t = t.toLowerCase();
  return t;
}
